export class DmDonViModel {
  constructor() { }
  public id: number;
  public maDonVi: string;
  public tenDonVi: string;
  public moTa: string;
  public thuTu: number;
  public parents: DmDonViModel;
  public parentId: number;
  public hienTieuDe: boolean;
}

export class DmDonViSearch {
  constructor(pageNumber?: number,
              pageSize?: number,
              keyword?: string) {
    this.pageNumber = pageNumber || 1;
    this.pageSize = pageSize || 10;
    this.keyword = keyword;

  }
  public pageNumber: number;
  public pageSize: number;
  public keyword: string;
}
